import { type Brand } from '@/core'
import { DateFormatter } from '@/format'
import { type OwnTableColumnConfig } from '@/ui'

export const brandTableColumns: Array<OwnTableColumnConfig<Brand>> = [
  {
    body: {
      color: 'primary',
      font: 'subtitle',
    },
    hideLabel: true,
    key: 'name',
  },
  {
    body: {
      format: DateFormatter,
    },
    key: 'createdAt',
    width: 150,
  },
]
